import { fetchPartnerRequestList } from 'legacy/lut/services/partner/fetchPartnerRequestList'

import { IPartner } from 'clickNgo/entities/partner/models'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import Logger from 'core/utils/Logger'

export const fetchTaxIdDuplication = async (
  {
    partnerId = '',
    taxId,
    topPartnerId = '',
  }: Partial<Pick<IPartner, 'partnerId' | 'topPartnerId'>> & Pick<IPartner, 'taxId'>,
  options?: ICrudFetchOptions
) => {
  const cacheKey = `fetchTaxIdDuplication-${taxId}-${partnerId}-${topPartnerId}`

  if (!taxId) {
    return []
  }

  const filters: IDataProviderFilter = {
    logic: Logic.AND,
    filters: [
      {
        field: 'TaxID',
        operator: Operator.EQUAL,
        value: taxId,
      },
    ],
  }

  if (partnerId) {
    filters.filters.push({
      field: 'PartnerID',
      operator: Operator.NOTEQUAL,
      value: partnerId,
    })
  }

  if (topPartnerId) {
    filters.filters.push({
      field: 'TopPartnerID',
      operator: Operator.NOTEQUAL,
      value: topPartnerId,
    })
  }

  return fetchPartnerRequestList([filters], { ...options, cacheKey })
    .then((result = []) => {
      return result
    })
    .catch((e) => {
      Logger.error(e)
      return []
    })
}
